module.exports = __webpack_public_path__ + "img/pc-hk.7f60101b.jpg";